import { gql } from '@apollo/client';

export const ADD_NEWSLETTER_RECIPIENT = gql`
	mutation AddNewsletterRecipient($path: String!, $input: NewsletterRecipientInput!) {
		addNewsletterRecipient(path: $path, input: $input)
	}
`;